import { LitElement, html, css } from 'lit';

export default class CzCombobox extends LitElement {
	static styles = [
		css`
			:host {
				display: block;
			}
			slot {
				box-sizing: border-box;
			}
		`
	];

	static properties = {
		autocomplete: {},
	};

	get select() {
		return this._select ??= this.querySelector('select');
	}

	/**
	 * bake your own combobox 
	 */
	bakeComponent() {

		return false;
	}

	updated(changedProperties) {
		if (changedProperties?.has('autocomplete')) {
			this.bakeComponent();
		}
	}

	render() {
		return html`<slot></slot>`;
	}
}

customElements.define('cz-combobox', CzCombobox);
